<template>
  <div class="page">
    <div class="page_top">
      <div class="sechout">
        <div class="sech-left" @click="closeContractSigned()">
          <van-icon name="arrow-left" color="#ffffff" size="20" />
        </div>
      </div>
      <div class="role" @click="roleType_show = true">
        <div>{{rolyTypeMap[roleType]}}</div>
        <img class="arrow_right" src="../../assets/house/arrow_right.png" alt="">
      </div>
      <div class="page_top_filter">
        <div class="page_top_filter_result" @click="selmissionData()">
          <div class="page_top_filter_result_txt">{{missionSelResult}}</div>
          <img class="pullDown" src="../../assets/house/pullDown.png" alt="">
        </div>
        <div class="page_top_filter_condition">
          <div v-for="(item,index) in missionSelType_arr" :key="'missionSelType'+index"
            :class="['page_top_filter_condition_item',missionSelTypeVal == item.val?'page_top_filter_condition_item_action':'']"
            @click="selmissionCondition(item.val)">
            {{item.name}}</div>
        </div>
      </div>
    </div>
    <div class="page_content">
      <div class="page_content_item">
        <div class="page_content_item_title">
          <div class="page_content_item_title_txt">总览</div>
          <div class="page_content_item_title_scope">
            数据范围：{{missionSelTypeVal == 1?mission_year+'.'+mission_month:mission_year+'-'+missionSelResult}}</div>
        </div>
        <div class="page_content_item_data_loop">
          <div class="page_content_item_data_loop_item" v-if="rental_estate_show">
            <van-circle v-model="currentRate1" layer-color="#f5f5f5" size="56px" :rate="rental_estate_num" :speed="20"
              :color="rental_estate_num > 100?{'0%':'#FC4242','100%':'#FC4242'}:{'0%': '#F28B49',
        '100%': '#FDE076'}" :stroke-width="100" :text="rental_estate_num+'%'" />
            <div class="page_content_item_data_loop_item_name">租赁房源</div>
          </div>
          <div class="page_content_item_data_loop_item" v-if="selling_estate_show">
            <van-circle v-model="currentRate2" layer-color="#f5f5f5" size="56px" :rate="selling_estate_num" :speed="20"
              :color="selling_estate_num > 100?{'0%':'#FC4242','100%':'#FC4242'}:{'0%': '#F28B49',
        '100%': '#FDE076'}" :stroke-width="100" :text="selling_estate_num+'%'" />
            <div class="page_content_item_data_loop_item_name">可售房源</div>
          </div>
          <div class="page_content_item_data_loop_item" v-if="leasing_transaction_show">
            <van-circle v-model="currentRate3" layer-color="#f5f5f5" size="56px" :rate="leasing_transaction_num"
              :speed="20" :color="leasing_transaction_num > 100?{'0%':'#FC4242','100%':'#FC4242'}:{'0%': '#35DD7D',
        '100%': '#5ADEF5'}" :stroke-width="100" :text="leasing_transaction_num+'%'" />
            <div class="page_content_item_data_loop_item_name">租赁业务</div>
          </div>
          <div class="page_content_item_data_loop_item" v-if="investment_promotion_show">
            <van-circle v-model="investment_promotion.key" layer-color="#f5f5f5" size="56px"
              :rate="investment_promotion.value" :speed="20" :color="investment_promotion.value > investment_promotion.key?{'0%':'#FC4242','100%':'#FC4242'}:{'0%': '#7693FD',
        '100%': '#C88BFF'}" :stroke-width="100" :text="investment_promotion.value.toString()" />
            <div class="page_content_item_data_loop_item_name">招商加盟</div>
          </div>
        </div>
      </div>
      <div class="page_content_item">
        <div class="page_content_item_title">
          <div class="page_content_item_title_txt">详情</div>
          <div class="page_content_item_title_scope">
            数据范围：{{missionSelTypeVal == 1?mission_year+'.'+mission_month:mission_year+'-'+missionSelResult}}</div>
        </div>
        <div class="page_content_item_data_bar">
          <div class="page_content_item_data_bar_item" v-if="rental_estate_show">
            <div class="page_content_item_data_bar_item_tit">
              <div class="page_content_item_data_bar_item_tit_txt">租赁房源</div>
              <div class="page_content_item_data_bar_item_tit_data">
                <img v-if="rental_estate_num> 100" class="excess_complete" src="../../assets/house/excess_complete.png"
                  alt="">
                <img v-if="rental_estate_num == 100" class="complete" src="../../assets/house/complete.png" alt="">
                <div class="page_content_item_data_bar_item_tit_data_statistical">
                  {{rental_estate.value}}/{{rental_estate.key}}</div>
              </div>
            </div>
            <van-progress :percentage="rental_estate_num>100?'100':rental_estate_num" :show-pivot='false'
              :color="rental_estate_barColor" />
          </div>
          <div class="page_content_item_data_bar_item" v-if="selling_estate_show">
            <div class="page_content_item_data_bar_item_tit">
              <div class="page_content_item_data_bar_item_tit_txt">可售房源</div>
              <div class="page_content_item_data_bar_item_tit_data">
                <img v-if="selling_estate_num> 100" class="excess_complete" src="../../assets/house/excess_complete.png"
                  alt="">
                <img v-if="selling_estate_num == 100" class="complete" src="../../assets/house/complete.png" alt="">
                <div class="page_content_item_data_bar_item_tit_data_statistical">
                  {{selling_estate.value}}/{{selling_estate.key}}</div>
              </div>
            </div>
            <van-progress :percentage="selling_estate_num>100?'100':selling_estate_num" :show-pivot='false'
              :color="selling_estate_barColor" />
          </div>
          <div class="page_content_item_data_bar_item" v-if="leasing_transaction_show">
            <div class="page_content_item_data_bar_item_tit">
              <div class="page_content_item_data_bar_item_tit_txt">租赁业务</div>
              <div class="page_content_item_data_bar_item_tit_data">
                <img v-if="leasing_transaction_num> 100" class="excess_complete"
                  src="../../assets/house/excess_complete.png" alt="">
                <img v-if="leasing_transaction_num == 100" class="complete" src="../../assets/house/complete.png"
                  alt="">
                <div class="page_content_item_data_bar_item_tit_data_statistical">
                  {{leasing_transaction.value}}/{{leasing_transaction.key}}</div>
              </div>
            </div>
            <van-progress :percentage="leasing_transaction_num>100?'100':leasing_transaction_num" :show-pivot='false'
              :color="leasing_transaction_barColor" />
          </div>
          <div class="page_content_item_data_bar_item" v-if="investment_promotion_show">
            <div class="page_content_item_data_bar_item_tit">
              <div class="page_content_item_data_bar_item_tit_txt">招商加盟</div>
              <div class="page_content_item_data_bar_item_tit_data">
                <img v-if="investment_promotion_num> 100" class="excess_complete"
                  src="../../assets/house/excess_complete.png" alt="">
                <img v-if="investment_promotion_num == 100" class="complete" src="../../assets/house/complete.png"
                  alt="">
                <div class="page_content_item_data_bar_item_tit_data_statistical">
                  {{investment_promotion.value}}/{{investment_promotion.key}}</div>
              </div>
            </div>
            <van-progress :percentage="investment_promotion_num>100?'100':investment_promotion_num" :show-pivot='false'
              :color="investment_promotion_barColor" />
          </div>
        </div>
      </div>
    </div>

    <van-popup v-model="roleType_show" position="bottom" :style="{ height: '40%' }">
      <van-picker show-toolbar title="请选择" :columns="rolePopList" @confirm="selMissionRole" />
    </van-popup>
    <van-popup v-model="mission_date_show" position="bottom" :style="{ height: '40%' }">
      <van-datetime-picker v-if="missionSelTypeVal == 1" v-model="currentDate" type="year-month" title="请选择"
        :min-date="minDate" :max-date="maxDate" @cancel="mission_date_show = false" @confirm="missionDateSubmit()"
        :formatter="formatter" />
      <div v-if="missionSelTypeVal == 2">
        <van-picker show-toolbar title="请选择" :columns="mission_quarter_option" @confirm="selMissionQuarter" />
      </div>
    </van-popup>
    <div class="loading" v-if="loading">
      <img src="../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        loading: false,
        rolyTypeMap: {
          1: '普通会员',
          2: '加盟门店',
          10: '市场专员A',
          20: '市场专员B',
          30: '区域经理',
          40: '地产顾问',
          50: '地产内部员工',
          60: '地产招商经理',
          70: '加盟门店内部员工',
          80: '普通运营商',
          90: '市级运营商',
          100: '省级运营商',
          110: '集团内部员工'
        },
        mission_date_show: false,
        mission_quarter_show: false,
        rolePopList: [],
        roleType: 0,
        roleType_show: false,
        missionSelResult: '',
        nowMonth: '',
        mission_year: '',
        mission_month: '',
        quarter: '',
        mission_quarter_option: [],
        missionSelTypeVal: 1,
        missionSelType_arr: [{
          name: '月',
          val: 1
        }, {
          name: '季',
          val: 2
        }],
        currentDate: new Date(),
        minDate: new Date(2010, 0, 1),
        maxDate: new Date(2021, 11, 1),
        years: [],
        currentRate1: 0,
        currentRate2: 0,
        currentRate3: 0,
        currentRate4: 0,
        rental_estate_num: 0,
        selling_estate_num: 0,
        leasing_transaction_num: 0,
        investment_promotion_num: 0,
        rental_estate: { //租赁房源收集
          key: 0,
          value: 0
        },
        selling_estate: { //可售房源收集
          key: 0,
          value: 0
        },
        leasing_transaction: { //租赁业务指标
          key: 0,
          value: 0
        },
        investment_promotion: { //招商加盟指标
          key: 0,
          value: 0
        },
        rental_estate_show: false,
        selling_estate_show: false,
        leasing_transaction_show: false,
        investment_promotion_show: false,
        percentage: 110,
        rental_estate_barColor: "linear-gradient(90deg, #F28B49 0%, #FDE076 100%)",
        selling_estate_barColor: "linear-gradient(90deg, #F28B49 0%, #FDE076 100%)",
        leasing_transaction_barColor: "linear-gradient(90deg, #35DD7D 0%, #5ADEF5 100%)",
        investment_promotion_barColor: "linear-gradient(90deg, #7693FD 0%, #C88BFF 100%);",
        loading: false,
      }
    },
    created() {
      if (this.$route.query.token) {
        this.$api.setToken(this.$route.query.token);
      }
      this.getNowDate();
      this.getRoleList();
      for (let i = 0; i <= this.mission_year - 2010; i++) {
        this.years.push(2010 + i)
      }
    },
    methods: {
      findKey(obj, value, compare = (a, b) => a === b) {
        return Object.keys(obj).find(k => compare(obj[k], value))
      },
      getData() {
        this.loading = true
        this.$api.get('estate/member/store/assessment/criteri/task/progress', {
          role_type: this.roleType,
          type: this.missionSelTypeVal,
          time: this.mission_year + '-' + this.mission_month,
          year: this.mission_year,
          quarter: this.quarter
        }).then(res => {
          this.loading = false;
          if (res.rental_estate) {
            this.rental_estate = res.rental_estate
            this.rental_estate_show = true;
            if (this.rental_estate.value == 0) {
              this.rental_estate_num = 0
              this.rental_estate_barColor = "linear-gradient(90deg, #F28B49 0%, #FDE076 100%)"
            } else {
              this.rental_estate_num = ((this.rental_estate.value / this.rental_estate.key) * 100).toFixed(0)
              if (this.rental_estate_num <= 100) {
                this.rental_estate_barColor = "linear-gradient(90deg, #F28B49 0%, #FDE076 100%)"
              } else {
                this.rental_estate_barColor = '#FC4242'
              }
            }
          } else {
            this.rental_estate_show = false
          }
          if (res.selling_estate) {
            this.selling_estate = res.selling_estate
            this.selling_estate_show = true;
            if (this.selling_estate.value == 0) {
              this.selling_estate_num = 0
              this.selling_estate_barColor = "linear-gradient(90deg, #F28B49 0%, #FDE076 100%)"
            } else {
              this.selling_estate_num = ((this.selling_estate.value / this.selling_estate.key) * 100).toFixed(0)
              if (this.selling_estate_num <= 100) {
                this.selling_estate_barColor = "linear-gradient(90deg, #F28B49 0%, #FDE076 100%)"
              } else {
                this.rental_estate_barColor = '#FC4242'
              }
            }
          } else {
            this.selling_estate_show = false
          }
          if (res.leasing_transaction) {
            this.leasing_transaction = res.leasing_transaction
            this.leasing_transaction_show = true
            if (this.leasing_transaction.value == 0) {
              this.leasing_transaction_num = 0
              this.leasing_transaction_barColor = "linear-gradient(90deg, #35DD7D 0%, #5ADEF5 100%)"
            } else {
              this.leasing_transaction_num = ((this.leasing_transaction.value / this.leasing_transaction.key) * 100)
                .toFixed(0)
              if (this.leasing_transaction_num <= 100) {
                this.leasing_transaction_barColor = "linear-gradient(90deg, #35DD7D 0%, #5ADEF5 100%)"
              } else {
                this.leasing_transaction_barColor = '#FC4242'
              }
            }
          } else {
            this.leasing_transaction_show = false;
          }
          if (res.investment_promotion) {
            this.investment_promotion_show = true
            this.investment_promotion = res.investment_promotion;
            if (this.investment_promotion.value == 0) {
              this.investment_promotion_num = 0
              this.investment_promotion_barColor = "linear-gradient(90deg, #7693FD 0%, #C88BFF 100%);"
            } else {
              this.investment_promotion_num = ((this.investment_promotion.value / this.investment_promotion.key) *
                100).toFixed(0)
              if (this.investment_promotion_num <= 100) {
                this.investment_promotion_barColor = "linear-gradient(90deg, #7693FD 0%, #C88BFF 100%);"
              } else {
                this.investment_promotion_barColor = '#FC4242'
              }
            }
          } else {
            this.investment_promotion_show = false;
          }
        })
      },
      closeContractSigned() {
        this.params('success', 'success', 'closeContractSigned');
      },
      getNowDate() {
        var date = new Date();
        this.currentDate = date;
        var nowMonth = date.getMonth() + 1;
        if (nowMonth >= 1 && nowMonth <= 9) {
          nowMonth = "0" + nowMonth;
        }
        this.nowMonth = nowMonth
        this.mission_year = date.getFullYear();
        this.maxDate = new Date(this.mission_year, 11, 1)
        this.mission_month = nowMonth
        this.missionSelResult = `${this.mission_year}年${this.mission_month}月`
      },
      getNowQuarter() {
        if ([1, 2, 3].includes(Number(this.nowMonth))) {
          this.quarter = 1
          this.missionSelResult = '第一季度'
        }
        if ([4, 5, 6].includes(Number(this.nowMonth))) {
          this.quarter = 2
          this.missionSelResult = '第二季度'
        }
        if ([7, 8, 9].includes(Number(this.nowMonth))) {
          this.quarter = 3
          this.missionSelResult = '第三季度'
        }
        if ([10, 11, 12].includes(Number(this.nowMonth))) {
          this.quarter = 4
          this.missionSelResult = '第四季度'
        }
      },
      getRoleList() {
        this.loading = true
        this.$api.get('estate/member/store/assessment/criteri/users/role/type/list').then(res => {
          let roleList = []
          res.forEach((item) => {
            roleList.push(item)
            this.rolePopList.push(this.rolyTypeMap[item])
          })
          this.roleType = roleList[0]
          this.getData();
        })
      },
      selmissionCondition(value) {
        this.missionSelTypeVal = value
        if (this.missionSelTypeVal == 1) {
          this.quarter = ''
          this.getNowDate();
          this.getData()
        }
        if (this.missionSelTypeVal == 2) {
          this.mission_month = ''
          this.getNowQuarter();
          this.mission_quarter_option = [{
            values: this.years,
            defaultIndex: this.years.indexOf(this.mission_year),
          }, {
            values: ['第一季度', '第二季度', '第三季度', '第四季度'],
            defaultIndex: [1, 2, 3, 4].indexOf(this.quarter),
          }, ]
          this.getData()
        }
      },
      selmissionData() {
        this.mission_date_show = true
        if (this.missionSelTypeVal == 1) {}
        if (this.missionSelTypeVal == 2) {

        }
      },
      formatter(type, val) {
        if (type === 'year') {
          return `${val}年`;
        } else if (type === 'month') {
          return `${val}月`;
        }
        return val;
      },
      missionDateSubmit() {
        let date = new Date(this.currentDate)
        this.mission_year = date.getFullYear();
        this.mission_month = date.getMonth() + 1
        if (this.mission_month >= 1 && this.mission_month <= 9) {
          this.mission_month = '0' + this.mission_month
        }
        this.mission_date_show = false;
        this.missionSelResult = `${this.mission_year}年${this.mission_month}月`
        this.getData()
      },
      selMissionQuarter(value) {
        let quarterMap = {
          '第一季度': 1,
          '第二季度': 2,
          '第三季度': 3,
          '第四季度': 4,
        }
        this.mission_year = value[0];
        this.quarter = quarterMap[value[1]];
        this.missionSelResult = value[1]
        this.mission_date_show = false;
        this.getData()
      },
      selMissionRole(value) {
        this.roleType = this.findKey(this.rolyTypeMap, value)
        this.roleType_show = false;
        this.getData()
      },
    },
  }
</script>

<style lang="less" scoped>
  .page {
    box-sizing: border-box;
    height: 100%;
    background-color: #f5f5f5;
    overflow: auto;
  }

  .top {
    width: 100%;
    height: var(--status-height);
    background-color: red;
  }

  .page_top {
    height: 208px;
    background: url('../../assets/house/missionTopBg.png') no-repeat right top;
    position: relative;
  }

  .sechout {
    height: 43px;
    padding: var(--status-height) 19px 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .sech-left,
  .sech-right {
    width: 104px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .role {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    font-size: 24px;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 33px;
  }

  .arrow_right {
    width: 22px;
  }

  .page_top_filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px
  }

  .page_top_filter_result {
    width: 114px;
    height: 36px;
    padding-left: 12px;
    padding-right: 8px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.8);
  }

  .page_top_filter_result_txt {
    font-size: 12px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 17px;
  }

  .pullDown {
    width: 14px;
  }

  .page_top_filter_condition {
    display: flex;
    align-items: center;
  }

  .page_top_filter_condition_item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 40px;
    height: 36px;
    font-size: 12px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 17px;
    margin-left: 8px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.6);
  }

  .page_top_filter_condition_item_action {
    background: rgba(255, 255, 255, 0.3);
    border: 1px solid rgba(255, 255, 255, 0.8);
  }

  .page_content {
    height: 100%;
    overflow: auto;
    padding: 12px 16px 31px;
  }

  .page_content_item {
    min-height: 191px;
    background: #FFFFFF;
    border-radius: 12px;
    margin-bottom: 12px;
  }

  .page_content_item_title {
    padding: 24px 20px 28px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .page_content_item_title_txt {
    font-size: 16px;
    font-weight: 500;
    color: #222325;
    line-height: 22px;
  }

  .page_content_item_title_scope {
    font-size: 11px;
    font-weight: 400;
    color: #ADADB7;
    line-height: 15px;
  }

  .page_content_item_data_loop {
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .page_content_item_data_loop_item {
    width: 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .page_content_item_data_loop_item_name {
    font-size: 12px;
    font-weight: 400;
    color: #222325;
    line-height: 17px;
    margin-top: 12px;
  }

  .page_content_item_data_bar {
    padding: 0 20px 8px;
  }

  .page_content_item_data_bar_item {
    margin-bottom: 32px;
  }

  .page_content_item_data_bar_item_tit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .page_content_item_data_bar_item_tit_txt {
    font-size: 14px;
    font-weight: 400;
    color: #222325;
    line-height: 20px;
  }

  .page_content_item_data_bar_item_tit_data {
    display: flex;
    align-items: center;
  }

  .excess_complete {
    width: 60px;
    margin-right: 8px;
  }

  .complete {
    width: 40px;
    margin-right: 8px;
  }

  .page_content_item_data_bar_item_tit_data_statistical {
    font-size: 16px;
    font-weight: bold;
    color: #222325;
    line-height: 19px;
  }

  .loading {
    text-align: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 100%;
    // background: rgba(0, 0, 0, 0.3);

    img {
      width: 35%;
      margin-top: 65%;
    }
  }
</style>